<template>
  <div>
    <div class="models border border-info rounded p-2">
      <div
        class="checkModels d-flex justify-content-between align-items-baseline mb-2"
      >
        <b-row>
          <b-col sm="12">
            <div class="d-flex">
              <b-form-checkbox
                class="ml-2"
                v-model="models.checkModels"
              >
                <p class="btn p-0 m-0 text-info">
                  Models
                </p>
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6">
            <div v-if="models.checkModels">
              <label>Score:</label>
              <b-form-input
                v-model="models.scoreForModels"
                placeholder="Enter Score"
                :class="{
                  'form-group-error':
                    $v.models.scoreForModels.$error,
                }"
              />
              <span
                class="input-error-message"
                v-if="
                  !$v.models.scoreForModels.required &&
                  $v.models.scoreForModels.$dirty
                "
              >
                Score is mandatory!
              </span>
            </div>
          </b-col>

          <b-col sm="6">
            <div v-if="models.checkModels">
              <label>Best of score:</label>
              <b-form-input
                v-model="models.best_of_scores"
                placeholder="Optional"
                type="number"
                min="0"
              />
              <small class="form-text text-muted">
                Number of best scores will be considered
              </small>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-collapse
        v-model="models.checkModels"
        class="mt-2"
      >
        <div class="mb-2">
          <span class="font-weight-bolder">
            Choose Score Type:
          </span>
        </div>

        <table class="table table-bordered table-striped">
          <thead class="thead-dark">
            <tr>
              <th></th>
              <th>Models</th>
              <th v-if="!activity_simple_calculation">
                Percent Weightage
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="modelsFromApi.length === 0">
              <td colspan="100" class="text-center text-danger">
                No Data Found!
              </td>
            </tr>

            <tr
              v-for="(model, index) in modelsFromApi"
              :key="index"
            >
              <td>
                <b-form-checkbox
                  size="sm"
                  v-model="
                    modelsConfigStructure[model.id].checkbox
                  "
                />
              </td>

              <td>{{ model.name }}</td>

              <td
                v-if="!activity_simple_calculation"
                class="text-center"
              >
                <b-form-input
                  v-if="
                    modelsConfigStructure[model.id].checkbox
                  "
                  placeholder="Enter Percentage"
                  v-model="
                    modelsConfigStructure[model.id].input
                  "
                  @blur="$v.modelsConfigStructure.$each.$touch()"
                />

                <div
                  v-if="
                    modelsConfigStructure[model.id].checkbox &&
                    $v.modelsConfigStructure.$each[model.id]
                      .input.$error
                  "
                  class="text-danger"
                >
                  <span
                    v-if="
                      !$v.modelsConfigStructure.$each[model.id]
                        .input.required
                    "
                  >
                    This field is required.
                  </span>
                  <span
                    v-if="
                      !$v.modelsConfigStructure.$each[model.id]
                        .input.customValidation
                    "
                  >
                    All values must be equal or sum to 100.
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { requiredIf } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  props: ["saved_configs", "courseReport", "activity_simple_calculation"],

  data() {
    return {
      models: {
        checkModels: false,
        scoreForModels: 20,
        best_of_scores: "",
      },
      modelsFromApi: [],
      modelsConfigStructure: {},
    };
  },

  async created() {
    await this.getModels();

    const saved =
      this.saved_configs.activity_catagory_configs.models;

    if (saved?.enable) {
      this.models = {
        checkModels: saved.enable,
        scoreForModels: saved.score,
        best_of_scores: saved.best_of_scores,
      };

      Object.keys(saved.resourses.exam || {}).forEach((key) => {
        if (this.modelsConfigStructure[key]) {
          this.modelsConfigStructure[key].checkbox = true;
          this.modelsConfigStructure[key].input =
            saved.resourses.exam[key].persantage_of_wightage;
        }
      });
    }
  },

  validations: {
    models: {
      scoreForModels: {
        required: requiredIf(function () {
          return this.models.checkModels;
        }),
      },
    },

    modelsConfigStructure: {
      $each: {
        input: {
          required() {
            return Object.values(this.modelsConfigStructure).some(
              (c) => c.checkbox
            );
          },

          customValidation() {
            if (
              !this.models.checkModels ||
              this.activity_simple_calculation
            )
              return true;

            const values = Object.values(
              this.modelsConfigStructure
            )
              .filter((c) => c.checkbox)
              .map((c) => Number(c.input));

            if (!values.length) return true;

            const allSame = values.every(
              (v) => v === values[0]
            );
            const sum100 =
              values.reduce((a, b) => a + b, 0) === 100;

            return allSame || sum100;
          },
        },
      },
    },
  },

  methods: {
    async checkValidation() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },

    async getModels() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/course/${this.courseReport.course_id}/exams`;

      const response = await this.$axios.get(url);

      response.data.forEach((item) => {
        if (item.activity_type === "models") {
          this.$set(this.modelsConfigStructure, item.id, {
            checkbox: false,
            input: "",
          });

          this.modelsFromApi.push({
            id: item.id,
            name: item.name,
            maximum_mark: item.maximum_mark,
            date: item.end_at
              ? moment(item.end_at)
              : null,
          });
        }
      });
    },
  },
};
</script>

<style>
.models p {
  font-size: 16px;
  font-weight: 600;
}
</style>
